import { render, staticRenderFns } from "./EditFormPage.vue?vue&type=template&id=47a47d0c"
import script from "./EditFormPage.vue?vue&type=script&lang=js"
export * from "./EditFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports